import { createSelector } from 'reselect'
import getAssetSelector from 'redux/selectors/assets/asset_selector'
import mediaTypes from 'helpers/enums/mediaTypes'
import qualitiesFormatter from 'helpers/interactive_video/qualities_formatter'

const getInteractiveVideoCreation = state => state.interactiveVideoCreation
const getInteractiveVideo = state => state.interactiveVideo

export default createSelector(
	[ getInteractiveVideoCreation, getInteractiveVideo, getAssetSelector ],
	(interactiveVideoCreation, interactiveVideo, getAsset) => {
		const videoAsset = getAsset(interactiveVideoCreation.media.asset.uid, mediaTypes.VIDEO)
		const { versions } = videoAsset ? videoAsset : {}
		const versionSizes = versions ? versions[0].videos : {}

		return qualitiesFormatter(versionSizes, interactiveVideo.settings.selectedVideoQuality)
	}
)
